import React from 'react';

const AiRobot = ({ width, height }: { width?: string; height?: string }) => {
    return (
        <svg width={width ?? '42'} height={height ?? '42'} viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g filter='url(#filter0_d_5261_44148)'>
                <g clipPath='url(#clip0_5261_44148)'>
                    <mask id='mask0_5261_44148' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='3' y='1' width='36' height='37'>
                        <path d='M39 1.5H3V37.5H39V1.5Z' fill='white' />
                    </mask>
                    <g mask='url(#mask0_5261_44148)'>
                        <path fillRule='evenodd' clipRule='evenodd' d='M39 1.15384V37.8461H3V1.15384H39Z' fill='url(#paint0_linear_5261_44148)' />
                        <mask id='mask1_5261_44148' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='2' y='8' width='38' height='39'>
                            <path d='M2.10596 8.48074H39.8021V46.1769H2.10596V8.48074Z' fill='white' />
                        </mask>
                        <g mask='url(#mask1_5261_44148)'>
                            <path
                                d='M8.00028 18.7844C9.39985 18.7844 10.5362 20.1971 10.5362 21.9371C10.5362 23.6771 9.39985 25.0899 8.00028 25.0899C6.6007 25.0899 5.46436 23.6771 5.46436 21.9371C5.46436 20.1971 6.6007 18.7844 8.00028 18.7844Z'
                                fill='#E9EBEF'
                            />
                            <path
                                d='M33.9998 18.7844C35.3994 18.7844 36.5357 20.1971 36.5357 21.9371C36.5357 23.6771 35.3994 25.0899 33.9998 25.0899C32.6002 25.0899 31.4639 23.6771 31.4639 21.9371C31.4639 20.1971 32.6002 18.7844 33.9998 18.7844Z'
                                fill='#E9EBEF'
                            />
                            <path
                                d='M20.7261 28.7453C20.1607 28.7453 14.4662 28.2426 13.7499 32.0327C13.3762 34.01 13.6438 38.0208 15.9161 40.2761C17.6778 42.0246 20.2166 41.937 20.8175 41.9503C21.4363 41.9641 24.4159 42.069 26.1399 40.3281C28.2344 38.213 28.7222 33.9999 28.2535 31.9508C27.5599 28.9184 23.0564 28.7453 20.7261 28.7453Z'
                                fill='url(#paint1_linear_5261_44148)'
                            />
                            <path
                                d='M20.8853 28.9737C23.7475 28.9737 26.0714 29.6391 26.0714 30.4587C26.0714 31.2783 23.7475 31.9437 20.8853 31.9437C18.0231 31.9437 15.6992 31.2783 15.6992 30.4587C15.6992 29.6391 18.0231 28.9737 20.8853 28.9737Z'
                                fill='#D9DBE3'
                            />
                            <path
                                d='M20.8853 28.9737C23.7475 28.9737 26.0714 29.6391 26.0714 30.4587C26.0714 31.2783 23.7475 31.9437 20.8853 31.9437C18.0231 31.9437 15.6992 31.2783 15.6992 30.4587C15.6992 29.6391 18.0231 28.9737 20.8853 28.9737Z'
                                stroke='#D0D3D8'
                                strokeWidth='0.0456923'
                            />
                            <path
                                d='M33.017 17.0023C27.6253 8.68633 12.5468 10.2399 8.98281 17.3679C7.68401 19.9655 5.51019 27.0546 13.8262 27.9685C15.3943 28.1408 28.3563 28.0599 28.3563 28.0599C28.3563 28.0599 31.7633 27.8758 33.4011 25.4802C34.6345 23.676 34.937 19.9637 33.017 17.0023Z'
                                fill='url(#paint2_linear_5261_44148)'
                            />
                            <path
                                d='M31.5588 21.1146V22.6682C31.5588 24.2821 30.2123 25.5925 28.5538 25.5925H13.8575C12.1991 25.5925 10.8525 24.2821 10.8525 22.6682V21.1146C10.8525 19.5007 12.1991 18.1903 13.8575 18.1903H28.5538C30.2123 18.1903 31.5588 19.5007 31.5588 21.1146Z'
                                fill='#3666CD'
                            />
                            <path
                                d='M22.3705 18.2018C22.3073 18.4545 22.6675 23.0109 18.9893 25.4783H29.1786C29.1786 25.4783 31.4176 25.5696 31.5546 21.8C31.6235 19.9049 30.9035 18.2589 28.9159 18.2132C26.9283 18.1675 22.3705 18.2246 22.3705 18.2018Z'
                                fill='#2B5BBE'
                            />
                            <path
                                d='M15.5629 20.5206V23.1251C15.5629 23.579 15.1943 23.9476 14.7404 23.9476C14.2865 23.9476 13.918 23.579 13.918 23.1251V20.5206C13.918 20.0667 14.2865 19.6982 14.7404 19.6982C15.1943 19.6982 15.5629 20.0667 15.5629 20.5206Z'
                                fill='#ECF2FF'
                            />
                            <path
                                d='M28.265 20.5206V23.1251C28.265 23.579 27.8965 23.9476 27.4426 23.9476C26.9887 23.9476 26.6201 23.579 26.6201 23.1251V20.5206C26.6201 20.0667 26.9887 19.6982 27.4426 19.6982C27.8965 19.6982 28.265 20.0667 28.265 20.5206Z'
                                fill='#ECF2FF'
                            />
                            <path
                                d='M10.8788 31.1441C8.18296 34.4796 9.11965 38.4777 9.48519 39.7114C9.69066 40.4049 10.5824 40.6446 11.0723 40.364C11.4539 40.1455 11.4749 39.4945 11.4956 39.2545C11.9069 34.5025 12.5923 32.2636 12.775 31.7609C12.8602 31.5269 12.7507 30.9454 12.3476 30.7848C11.8851 30.6004 11.1013 30.8688 10.8788 31.1441Z'
                                fill='#EFEFEF'
                            />
                            <path
                                d='M31.0411 32.1738C34.2752 29.3571 34.0471 25.2571 33.9013 23.9787C33.8194 23.2601 32.9828 22.8692 32.4516 23.0604C32.0379 23.2093 31.9042 23.8468 31.842 24.0796C30.6119 28.6879 29.5481 30.7738 29.2808 31.2371C29.1563 31.4528 29.1632 32.0444 29.5323 32.2726C29.9557 32.5345 30.7742 32.4063 31.0411 32.1738Z'
                                fill='url(#paint3_linear_5261_44148)'
                            />
                        </g>
                    </g>
                </g>
            </g>
            <defs>
                <filter id='filter0_d_5261_44148' x='0.230769' y='0.115385' width='41.5385' height='41.5385' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                    <feOffset dy='1.38462' />
                    <feGaussianBlur stdDeviation='1.38462' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0' />
                    <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5261_44148' />
                    <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5261_44148' result='shape' />
                </filter>
                <linearGradient id='paint0_linear_5261_44148' x1='3.95927' y1='2.27699' x2='38.0619' y2='36.7626' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#00C0DA' />
                    <stop offset='0.7' stopColor='#3667CE' />
                </linearGradient>
                <linearGradient id='paint1_linear_5261_44148' x1='14.3749' y1='34.0913' x2='25.8893' y2='33.9999' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#F3F3F3' />
                    <stop offset='0.65' stopColor='#D9DEE3' />
                    <stop offset='1' stopColor='#D3D3D3' />
                </linearGradient>
                <linearGradient id='paint2_linear_5261_44148' x1='8.4345' y1='24.5873' x2='31.0065' y2='24.6786' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#F3F3F3' />
                    <stop offset='0.65' stopColor='#D9DEE3' />
                    <stop offset='1' stopColor='#CBCBCB' />
                </linearGradient>
                <linearGradient id='paint3_linear_5261_44148' x1='33.1141' y1='29.261' x2='28.9691' y2='27.6405' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#CECECE' />
                    <stop offset='0.65' stopColor='#EDEDED' />
                    <stop offset='1' stopColor='#EFEFEF' />
                </linearGradient>
                <clipPath id='clip0_5261_44148'>
                    <rect x='3' y='1.5' width='36' height='36' rx='18' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default AiRobot;
